import { ModalDialog } from '@fukuri-admins/ui/common';
import { TextInputFieldController } from '@fukuri-admins/ui/common/Form';
import styles from './styles.module.scss';

type Props = {
  onClose: () => void;
  onConfirm: () => void;
};

export const EditClientAdminUserModalPresentation: React.FC<Props> = ({ onClose, onConfirm }) => {
  return (
    <ModalDialog
      isOpen
      title='管理者の編集'
      description=''
      onClose={onClose}
      onConfirm={onConfirm}
      confirmText='保存'
      variant='md'
    >
      <div className={styles.formContainer}>
        <TextInputFieldController
          name='fullName'
          fieldWrapperProps={{
            labelText: '氏名',
          }}
          textInput={{
            placeholder: '山田 太郎',
          }}
        />
        <TextInputFieldController
          name='email'
          fieldWrapperProps={{
            labelText: 'メールアドレス',
          }}
          textInput={{
            type: 'email',
            placeholder: 'example@example.com',
          }}
        />
        <TextInputFieldController
          name='password'
          fieldWrapperProps={{
            labelText: 'パスワード',
          }}
          textInput={{
            type: 'password',
          }}
        />
        <TextInputFieldController
          name='passwordConfirmation'
          fieldWrapperProps={{
            labelText: 'パスワード確認',
          }}
          textInput={{
            type: 'password',
          }}
        />
      </div>
    </ModalDialog>
  );
};
